module.exports = __webpack_public_path__ + "img/IT0000643853390.eaa28b64.png";